import UserBankRating from "../views/Rating/UserBankRating.vue";
import UserSiteRating from "../views/Rating/UserSiteRating.vue";
import RatingList from "../views/Rating/RatingList.vue";

const menu = [
  {
    title: "Рейтинги",
    icon: "star",
    url: "/rating",
    meta: { calcAdmin: true, bankir: true },
    id: 7,
  },
];

const routes = [
  {
    path: "/rating/userbank",
    name: "userbankrating",
    component: UserBankRating,
    meta: {
      forAuth: true,
      calcAdmin: true,
      bankir: true,
    },
  },
  {
    path: "/rating/usersite",
    name: "usersiterating",
    component: UserSiteRating,
    meta: {
      forAuth: true,
      calcAdmin: true,
      bankir: true,
    },
  },
  {
    path: "/rating",
    name: "rating",
    component: RatingList,
    meta: {
      forAuth: true,
      calcAdmin: true,
      bankir: true,
    },
  },
];

export default { menu, routes };
